var account = "حساب";
var accountSettings = "إعدادات الحساب";
var charging = "الشحن";
var contactInfo = "معلومات الاتصال";
var dashboard = "لوحة القيادة";
var home = "الصفحة الرئيسية";
var myProducts = "منتجاتي";
var orderHistory = "سجل الطلبات";
var paymentMethod = "طريقة الدفع";
var profileSettings = "إعدادات ملف التعريف";
var referAndEarn = "أرسل إحالة واربح";
var signOut = "تسجيل الخروج";
var ar_AE = {
	account: account,
	accountSettings: accountSettings,
	charging: charging,
	contactInfo: contactInfo,
	dashboard: dashboard,
	home: home,
	myProducts: myProducts,
	orderHistory: orderHistory,
	paymentMethod: paymentMethod,
	profileSettings: profileSettings,
	referAndEarn: referAndEarn,
	signOut: signOut
};

export { account, accountSettings, charging, contactInfo, dashboard, ar_AE as default, home, myProducts, orderHistory, paymentMethod, profileSettings, referAndEarn, signOut };
